export const LocationState = [
  { key: 'AL', text: 'Alabama - AL', value: 'AL' },
  { key: 'AK', text: 'Alaska - AK', value: 'AK' },
  { key: 'AZ', text: 'Arizona - AZ', value: 'AZ' },
  { key: 'AR', text: 'Arkansas - AR', value: 'AR' },
  { key: 'CA', text: 'California - CA', value: 'CA' },
  { key: 'CO', text: 'Colorado - CO', value: 'CO' },
  { key: 'CT', text: 'Connecticut - CT', value: 'CT' },
  { key: 'DE', text: 'Delaware - DE', value: 'DE' },
  { key: 'DC', text: 'District of Columbia - DC', value: 'DC' },
  { key: 'FL', text: 'Florida - FL', value: 'FL' },
  { key: 'GA', text: 'Georgia - GA', value: 'GA' },
  { key: 'HI', text: 'Hawaii - HI', value: 'HI' },
  { key: 'ID', text: 'Idaho - ID', value: 'ID' },
  { key: 'IL', text: 'Illinois - IL', value: 'IL' },
  { key: 'IN', text: 'Indiana - IN', value: 'IN' },
  { key: 'IA', text: 'Iowa - IA', value: 'IA' },
  { key: 'KS', text: 'Kansas - KS', value: 'KS' },
  { key: 'KY', text: 'Kentucky - KY', value: 'KY' },
  { key: 'LA', text: 'Louisiana - LA', value: 'LA' },
  { key: 'ME', text: 'Maine - ME', value: 'ME' },
  { key: 'MD', text: 'Maryland - MD', value: 'MD' },
  { key: 'MA', text: 'Massachusetts - MA', value: 'MA' },
  { key: 'MI', text: 'Michigan - MI', value: 'MI' },
  { key: 'MN', text: 'Minnesota - MN', value: 'MN' },
  { key: 'MS', text: 'Mississippi - MS', value: 'MS' },
  { key: 'MO', text: 'Missouri - MO', value: 'MO' },
  { key: 'MT', text: 'Montana - MT', value: 'MT' },
  { key: 'NE', text: 'Nebraska - NE', value: 'NE' },
  { key: 'NV', text: 'Nevada - NV', value: 'NV' },
  { key: 'NH', text: 'New Hampshire - NH', value: 'NH' },
  { key: 'NJ', text: 'New Jersey - NJ', value: 'NJ' },
  { key: 'NM', text: 'New Mexico - NM', value: 'NM' },
  { key: 'NY', text: 'New York - NY', value: 'NY' },
  { key: 'NC', text: 'North Carolina - NC', value: 'NC' },
  { key: 'ND', text: 'North Dakota - ND', value: 'ND' },
  { key: 'OH', text: 'Ohio - OH', value: 'OH' },
  { key: 'OK', text: 'Oklahoma - OK', value: 'OK' },
  { key: 'OR', text: 'Oregon - OR', value: 'OR' },
  { key: 'PA', text: 'Pennsylvania - PA', value: 'PA' },
  { key: 'PR', text: 'Puerto Rico - PR', value: 'PR' },
  { key: 'RI', text: 'Rhode Island - RI', value: 'RI' },
  { key: 'SC', text: 'South Carolina - SC', value: 'SC' },
  { key: 'SD', text: 'South Dakota - SD', value: 'SD' },
  { key: 'TN', text: 'Tennessee - TN', value: 'TN' },
  { key: 'TX', text: 'Texas - TX', value: 'TX' },
  { key: 'UT', text: 'Utah - UT', value: 'UT' },
  { key: 'VT', text: 'Vermont - VT', value: 'VT' },
  { key: 'VA', text: 'Virginia - VA', value: 'VA' },
  { key: 'VI', text: 'Virgin Islands - VI', value: 'VI' },
  { key: 'WA', text: 'Washington - WA', value: 'WA' },
  { key: 'WV', text: 'West Virginia - WV', value: 'WV' },
  { key: 'WI', text: 'Wisconsin - WI', value: 'WI' },
  { key: 'WY', text: 'Wyoming - WY', value: 'WY' },
];

export const AuctionSystem = [
  { key: 'MANHEIM', text: 'Manheim', value: 'MANHEIM' },
  { key: 'BSC', text: 'BSC', value: 'BSC' },
  { key: 'ASI', text: 'Auction Edge - ASI', value: 'ASI' },
  { key: 'AOS', text: 'Auction Edge - AOS', value: 'AOS' },
  { key: 'XCIRA', text: 'XCIRA', value: 'XCIRA' },
  { key: 'AUCTION STREAMING', text: 'Auction Streaming', value: 'AUCTION STREAMING' },
];

export const DaysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
